import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
export const protobufPackage = "squareup.common";
function createBaseMoney() {
	return {
		$type: "squareup.common.Money",
		amount: undefined,
		currencyCode: undefined
	};
}
export const Money = {
	$type: "squareup.common.Money",
	encode(message, writer = new BinaryWriter()) {
		if (message.amount !== undefined) {
			writer.uint32(16).int64(message.amount);
		}
		if (message.currencyCode !== undefined) {
			writer.uint32(24).int32(message.currencyCode);
		}
		return writer;
	},
	decode(input, length) {
		const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
		const end = length === undefined ? reader.len : reader.pos + length;
		const message = createBaseMoney();
		while (reader.pos < end) {
			const tag = reader.uint32();
			switch (tag >>> 3) {
				case 2: {
					if (tag !== 16) {
						break;
					}
					message.amount = longToNumber(reader.int64());
					continue;
				}
				case 3: {
					if (tag !== 24) {
						break;
					}
					message.currencyCode = reader.int32();
					continue;
				}
			}
			if ((tag & 7) === 4 || tag === 0) {
				break;
			}
			reader.skip(tag & 7);
		}
		return message;
	},
	create(base) {
		return Money.fromPartial(base ?? {});
	},
	fromPartial(object) {
		const message = createBaseMoney();
		message.amount = object.amount ?? undefined;
		message.currencyCode = object.currencyCode ?? undefined;
		return message;
	}
};
function longToNumber(int64) {
	const num = globalThis.Number(int64.toString());
	if (num > globalThis.Number.MAX_SAFE_INTEGER) {
		throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
	}
	if (num < globalThis.Number.MIN_SAFE_INTEGER) {
		throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
	}
	return num;
}
